import moment from "moment";

const format = "DD.MM.YYYY";

export default function dateLocalFilter(date) {
  if (!date) return;
  if (moment(date, format).format(format) === date) return date;
  return date ? moment(date).utc(true).utcOffset('+05:00').format(format) : null
}
